import { CustomerPortalWidget } from 'api/customer-portal/types';

export enum CpDividerType {
  Rectangle = 'RECTANGLE',
  RectangleWithAShorterRightVertex = 'RECTANGLE_WITH_A_SHORTER_RIGHT_VERTEX',
  RoundedRectangle = 'ROUNDED_RECTANGLE',
  CurvedRectangle = 'CURVED_RECTANGLE',
  PointedShape = 'POINTED',
}

export interface CpWidgetDividerProps {
  widget: CustomerPortalWidget;
  nextWidget?: CustomerPortalWidget;
}
